'use strict';

import React from 'react';
import { connect } from 'react-redux';
import FavoriteBase from './FavoriteBase';
import IconFavorite from '../../Icons/IconFavorite';
import IconActiveFavorite from '../../Icons/IconActiveFavorite';

class FavoriteFlatButton extends FavoriteBase {
  render () {
    return (
        this.state.active
        ? (
          <button onClick={this.handlerRemove} data-tip='Удалить из избранного' className='active button' >
            <IconActiveFavorite />
            <span>
              &nbsp;В&nbsp;избранном
            </span>
          </button>
        )
        : (
          <button onClick={this.handlerAdd} data-tip='Добавить в избранное' className='button'>
            <IconFavorite />
            <span>
              &nbsp;В&nbsp;избранное
            </span>
          </button>
        )
    );
  }
}

export default connect()(FavoriteFlatButton);



// WEBPACK FOOTER //
// ./src/ui/Controls/Favorite/FavoriteFlatButton.jsx